import getIdToken from './getIdToken';

const fetchData = async ({ url, method = 'GET', body = null, headers = {} }) => {
    try {
        const idToken = await getIdToken(); // Firebase token

        const options = {
            method,
            headers: {
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json',
                ...headers
            },
            redirect: 'manual',
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);

        if (!response.ok) {
            const errorBody = await response.text().catch(() => null);
            throw new Error(`HTTP ${response.status}: ${errorBody}`);
        }

        // for 302 or non-JSON
        let data = null;
        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
            data = await response.json().catch(() => null);
        }
        
        return data;

    } catch (error) {
        console.error('Error in fetchData:', error);
        throw error;
    }
};


export default fetchData;